var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize-observer",rawName:"v-resize-observer",value:(_vm.onResize),expression:"onResize"}],staticClass:"c-monaco-editor"})}
var staticRenderFns = []

export { render, staticRenderFns }